<template>
	<footer>
		<div class="footer-element">
			<div class="row">
				<div class="columns column3">
					<img
						src="~/assets/images/logo-metzlr-house-full-black.png"
						loading="lazy"
						alt="Metzlr House"
						class="footer-logo"
					/>
				</div>
				<div class="columns column3">
					<h3>{{ $t('contact') }}</h3>
					<p>
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>{{ defaults[locale].website.phone }}</span> </a
						><br />
						<a :href="`mailto:${defaults[locale].website.email}`"
							><span>{{ defaults[locale].website.email }}</span></a
						>
					</p>
					<social-media :socials="socials" />
				</div>
				<div class="columns column3">
					<h3>{{ defaults[locale].website.hotelName }}</h3>
					<p>
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span
						><br />
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span
						><br />
						<span>{{ defaults[locale].website.country }}</span
						><br />
					</p>
				</div>
				<div class="columns column3">
					<h3>{{ $t('footerNavigate') }}</h3>
					<p class="footer-nav">
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }} <br />
						</nuxt-link>
					</p>
				</div>
			</div>
		</div>
		<div class="footer-element author">
			<div class="row">
				<div class="columns column12 align-center">
					<p class="align-left">
						<span v-for="item in bottomfooter[locale]" :key="item.filename">
							<nuxt-link :to="item.filename">
								{{ item.header }}
							</nuxt-link>
							<span> | </span>
							<a v-if="defaults[locale].cookieConsent.published" href="#" @click.prevent="openConsent"
								>{{ $t('consentOpen') }}
							</a>
						</span>
					</p>
					<p class="align-right">
						<a :href="$t('siteByUrl')" target="_blank" rel="noopener noreferrer"> Hotel Website Design </a>
						by:
						<a :href="$t('siteByUrl')" target="_blank">
							<img class="siteByLogo" :src="$t('siteByLogo')" loading="lazy" alt="Site by" />
							Porter
						</a>
					</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script setup>
const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu, bottomfooter } = footer.value;
const { locale } = useI18n();

const { defaults, socials, fetchDefaults } = useDefaults();
const { openConsent } = useCookieConsent();

await fetchDefaults();
</script>

<style lang="scss" scoped>
.footer-element {
	padding: 75px 0 10px;
	font-size: 13px;
	border-top: 1px solid var(--contentblock-background-color);

	a {
		color: var(--body-color);

		&:hover {
			color: var(--cta-color);
		}
	}

	h3 {
		font-size: 22px;
	}
}

.footer-element.author {
	padding: 14px 0;
	font-size: 12px;
}

.author {
	.column12 {
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		font-size: 11px;
	}

	p {
		margin: 0;
	}

	img {
		max-width: 20px;
		margin: 0 1px 0 2px;
	}
}

.footer-logo {
	max-width: 160px;
	margin: 0 0 30px;
	width: 100%;
}

.socials a {
	color: #fff;
	background: var(--cta-color);
	width: 40px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 22px;
	margin: 5px 5px 5px 0;
	text-decoration: none;
}

.socials a:hover {
	color: #fff;
	background: var(--cta-color-hover);
}

@media (min-width: 921px) {
	.footer-element:first-child {
		padding: 0;

		.row {
			display: flex;
			flex-flow: row wrap;
			justify-content: space-between;
			align-items: stretch;

			.column3 {
				padding: 50px 20px;
				display: flex;
				flex-flow: column wrap;
				justify-content: flex-start;
				align-items: flex-start;
				width: 22%;
				margin: 0 3% 0 0;

				&:first-child {
					border-right: 1px solid var(--contentblock-background-color);
					justify-content: center;
				}
			}
		}
	}
}

@media (max-width: 920px) {
	.footer-element .columns {
		margin: 20px auto;
	}

	.author .columns {
		margin: 0;
		flex-flow: wrap column-reverse;
	}

	.author p {
		width: 100%;
		margin: 0 0 5px;
		text-align: center;
	}
}

@media (max-width: 680px) {
	.footer-element {
		text-align: center;
	}
}
</style>
